import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

import { ITinyBox } from '../interfaces';

export type IGetTinyBoxesRepoResponse = IRepoResponse<200, ITinyBox[]> | IRepoResponse<400 | 500, string>;

export type IGetTinyBoxesRepo = IRepo<[any], IGetTinyBoxesRepoResponse>;

export const GetTinyBoxesRepoType = Symbol.for('GetTinyBoxesRepo');

@bind(GetTinyBoxesRepoType)
export class GetTinyBoxesRepo implements IGetTinyBoxesRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: object) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/containers/options', query) });

      if (result.status === 200) {
        const data: ITinyBox[] = result.data.map((item) => ({ id: item.id, name: item.container_name }));

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
